import React from 'react'
import { ActionButton } from '@contrast-security-inc/design-system-actions'
import {
  PopoverMenu,
  MenuTrigger,
  MenuItem,
  Menu
} from '@contrast-security-inc/design-system-popovers'
import {
  IconDownload,
  IconSize
} from '@contrast-security-inc/design-system-foundations'
import { submitForm } from '../../../util'
import { useIntl } from 'react-intl'

export const actionTestID = 'vuln-export-test-id'

interface Props {
  readonly organizationID: string
  readonly selectedVulnerabilityIDs: string[]
  readonly isFreemiumOrganization: boolean
  size?: IconSize
}

export function ExportVulnerabilitiesAction({
  organizationID,
  selectedVulnerabilityIDs,
  isFreemiumOrganization,
  size
}: Props) {
  const baseURL = `${organizationID}/orgtraces/export`
  const data = selectedVulnerabilityIDs.map((value) => ({
    name: 'traces',
    value
  }))

  const { formatMessage } = useIntl()
  const iconSize: IconSize = size as IconSize

  return (
    <PopoverMenu testId="popover-menu">
      <Menu>
        <MenuItem
          itemID="csv"
          onClick={() => submitForm(`${baseURL}/csv`, data)}
        >
          CSV
        </MenuItem>
        {!isFreemiumOrganization ? (
          <MenuItem
            itemID="xml"
            onClick={() => submitForm(`${baseURL}/xml`, data)}
          >
            XML
          </MenuItem>
        ) : (
          <></>
        )}
      </Menu>
      <MenuTrigger>
        <ActionButton
          data-testid={actionTestID}
          testId={actionTestID}
          IconButtonProps={{
            Icon: IconDownload,
            'aria-label': formatMessage({ id: 'action_export_data' }),
            size: iconSize
          }}
          TooltipProps={{
            placement: 'top',
            body: formatMessage({ id: 'action_export_data' })
          }}
        />
      </MenuTrigger>
    </PopoverMenu>
  )
}
